module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.99f91b46.otf";